import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SignTransferModal from '../components/SignTransferModal'
import {
  actionCreators,
  ISignTransferState,
  selectError,
  selectIsOpen,
  selectIsSaving,
  selectMaxQuantity,
  selectSignTransfer,
} from '../modules/signTransfer'

export default connect(
  createStructuredSelector<ApplicationState, ISignTransferState>({
    error: selectError(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
    maxQuantity: selectMaxQuantity(),
    signTransfer: selectSignTransfer(),
  }),
  actionCreators,
)(SignTransferModal)
